import React, { useState } from 'react';
import env from 'env';
import { useRouter } from 'components';
import { useGet, usePost } from 'components';
import { ErrorPopup } from 'components';
import { getCategoryEditModel } from './categoryEditFormModel';
import { Redirect, Link } from "react-router-dom";
import { useForm } from 'form';
import { Button, ErrorMessage } from 'components';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import utils from 'utils';
import { FaGripLines } from 'react-icons/fa';
import { ImageSelector } from './imageSelector';

export function CategoryEdit(props) {
  const { query } = useRouter();
  const get = useGet();

  const categoryId = query.id || '';

  React.useEffect(() => {
    get.send(env.apiBase + `/api/categoryAdmin/getCategory/${categoryId}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;
  const model = getCategoryEditModel(data);
  console.log(model)

  return <CategoryEditForm model={model} data={data} categoryId={categoryId} />
}


export function CategoryEditForm({ model, data, categoryId }) {

  const form = useForm(model, {});
  const post = usePost();
  const post2 = usePost();
  const [productList, setProductList] = useState(data.productList);


  console.log("productList", productList);

  const render = (name) => form.renderControl(name);

  function save(e) {
    form.validateForm(e, () => {
      const value = { ...form.getValue() };

      console.log(value)
      //return;
      post.send(env.apiBase + "/api/categoryAdmin/saveCategory", value);
    })
  }

  function remove(e) {
    if (!window.confirm('Delete this??')) return;
    post.send(env.apiBase + "/api/categoryAdmin/removeCategory", { categoryId: categoryId });
  }

  function saveProductSorting(e) {
    post2.send(env.apiBase + "/api/categoryAdmin/saveproductsorting", { productList: productList });
  }

  // function suggestUrl() {
  //   const value = form.getValue();
  //   const categoryUrl = form.findControl('categorySlug');
  //   categoryUrl.value = utils.url.getSlug(value.categoryName);
  //   form.reset()
  // }

  if (post.status === 'done') {
    return <Redirect to="/admin/categories" />
  }

  if (post2.status === 'done') {
    return <Redirect to="/admin/categories" />
  }

  //const formVal = form.getValue();

  function onDragEndAttr(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    onAttributeOrderChanged(result.source.index, result.destination.index)
  }

  function onAttributeOrderChanged(srcInx, desInx) {
    utils.array.moveItem(productList, srcInx, desInx);
    setProductList([...productList]);
  }

  return (
    <div className="editor categoryEditor">
      <h1>Category Edit</h1>

      <section>
        <div className="row">
          <div className="col-md-12">{render('categoryName')}</div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <label className="label">Category Product Images</label>
            <ImageSelector form={form} data={data} fieldName="productImages" />
          </div>
        </div>
        {/* <div className="row">
          <div className="col-md-12">{render('categorySlug')}
            <div style={{ textAlign: 'right' }}>
              <button type="button" className="btn btn-outline-info btn-sm" onClick={suggestUrl}>Suggest URL from category name</button>
            </div>
          </div>
        </div> */}
        {/* <div className="row">
          <div className="col-md-6">{render('categoryStatus')}</div>
          <div className="col-md-6">{render('categoryId')}</div>
        </div> */}

        <div className="row">
          <div className="col-12 actions">
            <ErrorMessage errors={form.errors} />
            <ErrorMessage errors={post.errors} />
            <Button onClick={save} status={form.status}>Save</Button>
            {categoryId &&
              <Button onClick={remove} status={form.status} btnStyle="outline-primary">Delete</Button>}
            <Link className="btn btn-outline-dark" to="/admin/categories">Cancel</Link>
          </div>
        </div>
      </section>
      {
        (productList && productList.length > 0) &&
        <>
          <h1 style={{ display: 'inline-block' }}>Product Sorting</h1>
          <Button style={{ marginLeft: '1rem' }} onClick={saveProductSorting}> Save Product Sorting </Button>
          <section style={{ marginBottom: '1rem', maxWidth: '700px' }}>
            <DragDropContext onDragEnd={(result) => onDragEndAttr(result)}>
              <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {
                      productList.map((item, index) =>
                        <Draggable key={item.productId} draggableId={item.productId} index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              style={provided.draggableProps.style}
                              className="category__drag__container"
                            >
                              <div>
                                <div className="category__drag__icon"   {...provided.dragHandleProps}><FaGripLines title="Change order" /></div>
                                {item.productName}
                              </div>
                            </div>
                          )}
                        </Draggable>
                      )
                    }

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </section>
          <Button onClick={saveProductSorting}> Save Product Sorting </Button>
          <div style={{ marginBottom: '2rem' }}></div>
        </>
      }
    </div>
  );
}
